import type { UnwrapNestedRefs } from "vue";
import { defineComponent, onBeforeMount } from "vue";
import type { ExtractPropTypes } from "vue";
import { reactive } from "vue";
import { props } from "quick-vue-components/index";
import { getNoticesList } from "@user-center/api/common";
import { getToken } from "@user-center/utils/auth";
import moment from "moment";
import qs from "qs";
import { filterActiveNotices, isNoticeHiddenByScope } from "./noticeUtils";

export interface NoticeBarType {
  noticeBarState: UnwrapNestedRefs<NoticeBarStateType>;
  getListAction():void
}
export type NoticeBarStateType = {
  noticeDataVisible: boolean;

  viewNoticeIdx: number;
  findNoticeDatas: any[];
};
export const NoticeBarProps = props.buildProps({
  isShowBar: {
    type: Boolean,
    default: true,
  },
  autoPopup: {
    type: Boolean,
    default: true,
  },
  pageSize: {
    type: Number,
    default: 99,
  },
  storageScope: {
    type: String,
    default: "default",
  },
});
export type NoticeBarPropsType = ExtractPropTypes<typeof NoticeBarProps>;

export function useGetNoticesList(props?:NoticeBarPropsType): NoticeBarType {
  let noticeBarState: UnwrapNestedRefs<NoticeBarStateType> = reactive({
    noticeDataVisible: false,
    viewNoticeIdx: 0,
    findNoticeDatas: [],
  });
  function getListAction() {
    if (!getToken()) {
      noticeBarState.findNoticeDatas = [];
      noticeBarState.viewNoticeIdx = 0;
      noticeBarState.noticeDataVisible = false;
      return;
    }

    getNoticesList({ pageNo: 0, pageSize: props?.pageSize || 99 }).then((res: any): void => {
      if (res.success && res.data && res.data.dataList) {
        let findItems: any[] = filterActiveNotices(res.data.dataList || []);
        if (findItems.length) {
          noticeBarState.findNoticeDatas = findItems;
          noticeBarState.viewNoticeIdx = 0;
          if (
            props?.autoPopup !== false &&
            !window.sessionStorage.getItem("isNoticeBarOpen") &&
            !isNoticeHiddenByScope(props?.storageScope || "default")
          ) {
            window.sessionStorage.setItem("isNoticeBarOpen", "1");
            noticeBarState.noticeDataVisible = true;
          }
        }
      }
    });
  }

 
  return {
    getListAction,
    noticeBarState,
  };
}
